export var QueryDataSourceParameterValueType;
(function (QueryDataSourceParameterValueType) {
    QueryDataSourceParameterValueType[QueryDataSourceParameterValueType["Constant"] = 0] = "Constant";
    QueryDataSourceParameterValueType[QueryDataSourceParameterValueType["CurrentUserEmailAddress"] = 1] = "CurrentUserEmailAddress";
    QueryDataSourceParameterValueType[QueryDataSourceParameterValueType["CurrentUserAccountId"] = 2] = "CurrentUserAccountId";
    QueryDataSourceParameterValueType[QueryDataSourceParameterValueType["CurrentUserIdentifier"] = 3] = "CurrentUserIdentifier";
    QueryDataSourceParameterValueType[QueryDataSourceParameterValueType["CurrentFolderId"] = 4] = "CurrentFolderId";
    QueryDataSourceParameterValueType[QueryDataSourceParameterValueType["CurrentFolderName"] = 5] = "CurrentFolderName";
})(QueryDataSourceParameterValueType || (QueryDataSourceParameterValueType = {}));
;
